import type { StateCreator } from 'zustand';
import type { PatientTabsSliceType } from '../types';
import { getVisibleIds } from '../utils/getVisibleIds';

export const setActiveTabIndex: StateCreator<
  PatientTabsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  PatientTabsSliceType['setActiveTabIndex']
> = (set, get) => (targetIndex) => {
  const { tabs, activeTabIndex } = get().patientTabs;
  const visibleCount = getVisibleIds(tabs).length;

  const isInvalidTab = targetIndex < 0 || targetIndex >= visibleCount;
  const isCurrentTab = targetIndex === activeTabIndex;
  if (isInvalidTab || isCurrentTab) {
    return;
  }

  set(
    (state) => {
      state.patientTabs.activeTabIndex = targetIndex;
    },
    false,
    'patientTabs/setActiveTabIndex',
  );
};
